import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['label'];

  updateLabel({ target }) {
    const filename = target.files[0]?.name;

    if (filename) {
      this.labelTarget.textContent = filename;
    }
  }
}
